import type { IFilterChoiceItem } from '@/modules/universalStats/types/IFilterChoiceItem'

interface RawChoiceItem {
  id: string | number
  label?: string
  name?: string
  children?: RawChoiceItem[]
  childrens?: RawChoiceItem[]
}

/** Нормализует choice из API в IFilterChoiceItem (поддержка legacy: childrens). */
export function normalizeFilterChoice(item: RawChoiceItem): IFilterChoiceItem {
  const childNodes = item.children ?? item.childrens

  return {
    id: item.id,
    label: item.label ?? item.name ?? String(item.id),
    children: Array.isArray(childNodes)
      ? childNodes.map(normalizeFilterChoice)
      : undefined,
  }
}
